import { createFileRoute } from '@tanstack/react-router';
import { MyBillingIndex } from '@/pages/billing/MyBillingIndex';

export const Route = createFileRoute('/_authenticated/_app/settings/billing/payments')({
	component: MyBillingIndex,
});
